import { Inject, Injectable, Injector }from '@angular/core';

import { FootprintApiManager_DatasourceService } from './FootprintApiManager.datasource.index';


@Injectable({ providedIn: 'root' })
export class app_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.FootprintApiManager = this.injector.get(FootprintApiManager_DatasourceService);
  }

    public FootprintApiManager: FootprintApiManager_DatasourceService;
  public app: app_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
}

